/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tag: NonNullable<unknown> }} Tags_Add_Tag_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Add tag {tag}" |
*
* @param {Tags_Add_Tag_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_add_tag_aria_label = /** @type {((inputs: Tags_Add_Tag_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Add_Tag_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ajouter le tag ${i?.tag}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Füge das Tag ${i?.tag} hinzu`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Aggiungi tag ${i?.tag}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Добавить тег ${i?.tag}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Añadir etiqueta ${i?.tag}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`添加标签${i?.tag}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`タグ ${i?.tag} を追加`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`टैग ${i?.tag} जोड़ें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Adicionar etiqueta ${i?.tag}`)
	return /** @type {LocalizedString} */ (`Add tag ${i?.tag}`)
});